export const LOGGED_IN = 'LOGGED_IN';

export const LOGOUT = 'LOGOUT';